<script setup>
import { ref, watch } from 'vue';
import { useWhatsappQrStatusPolling } from 'dashboard/composables/useWhatsappQrStatusPolling';
import WhatsappQrReconnectModal from 'dashboard/routes/dashboard/painel/components/WhatsappQrReconnectModal.vue';

const { disconnectedInbox, dismissInbox, isDismissed } =
  useWhatsappQrStatusPolling();

const activeInboxId = ref(null);

watch(
  disconnectedInbox,
  inbox => {
    if (!inbox) {
      activeInboxId.value = null;
      return;
    }
    if (isDismissed(inbox.id)) return;
    activeInboxId.value = inbox.id;
  },
  { immediate: true }
);

const onClose = () => {
  if (activeInboxId.value) dismissInbox(activeInboxId.value);
  activeInboxId.value = null;
};
</script>

<template>
  <WhatsappQrReconnectModal
    v-if="activeInboxId"
    :inbox-id="activeInboxId"
    @close="onClose"
  />
</template>
